import { FunctionComponent, memo, useState } from "react";
import { IProps } from "./interaction-provider.types";
import { defaultContext, InteractionContext } from "../interaction-context/interaction-context";
import "./interaction-provider.scss";
import { Permission } from "@edgetier/watchtower-types";
import usePermission from "hooks-for/permissions/use-permission";

/**
 * Provide context to an interaction.
 * @param props.initialAreWritingIssuesVisible Should writing issues be visible be default.
 * @param props.children                       The interaction components.
 */
const InteractionProvider: FunctionComponent<IProps> = ({
    areWritingIssuesVisible: initialAreWritingIssuesVisible = defaultContext.areWritingIssuesVisible,
    children,
}) => {
    const [areWritingIssuesVisible, setAreWritingIssuesVisible] = useState(initialAreWritingIssuesVisible);
    const [isAddTagGroupSelectVisible, setIsAddTagGroupSelectVisible] = useState(
        defaultContext.isAddTagGroupSelectVisible
    );
    const [isTranslationActive, setIsTranslationActive] = useState(defaultContext.isTranslationActive);
    const { hasPermission } = usePermission(Permission.ViewAgent);

    return (
        <InteractionContext.Provider
            value={{
                ...defaultContext,
                areWritingIssuesVisible,
                hasViewAgentPermission: hasPermission ?? defaultContext.hasViewAgentPermission,
                setAreWritingIssuesVisible,
                isAddTagGroupSelectVisible,
                setIsAddTagGroupSelectVisible,
                isTranslationActive,
                setIsTranslationActive,
            }}
        >
            {children}
        </InteractionContext.Provider>
    );
};

export default memo(InteractionProvider);
